import { LanguageInfo } from '@@types/Api/Setting';

import { api } from '~/stores/providers/Api2';
import { find } from 'lodash';
import { action, observable, runInAction } from 'mobx';
import { map } from 'ramda';

const mapLanguagesToSelectItems = map((lang: LanguageInfo) => ({ label: lang.language, value: lang.iso8391Code }));

class LanguagesStore {
  @observable languages = [];

  @observable loadingLanguages = false;

  @action
  async loadLanguages() {
    this.loadingLanguages = true;
    try {
      const languages = await api.setting.fetchLanguages();
      runInAction(() => (this.languages = mapLanguagesToSelectItems(languages)));
    } finally {
      runInAction(() => (this.loadingLanguages = false));
    }
  }

  getByValue = (value) => find(this.languages, { value });
}

export default LanguagesStore;

export const languagesStore = new LanguagesStore();
